import gsap from 'gsap'
import Swiper, { EffectFade, Autoplay } from 'swiper'

const heroSlider = () => {
  const slider = new Swiper('.hero-slider.swiper', {
    effect: 'fade',
    modules: [EffectFade, Autoplay],
    fadeEffect: {
      crossFade: true,
    },
    speed: 2000,
    autoplay: {
      delay: 5000,
    },
    allowTouchMove: false,
  })

  const scaleUp = () => {
    gsap.fromTo(
      '.hero-slider .swiper-slide-active',
      {
        scale: 1,
      },
      {
        scale: 1.15,
        duration: 9.0,
        ease: 'linear',
      }
    )
  }

  scaleUp()

  slider.on('slideChangeTransitionStart', () => {
    scaleUp()
  })
}

export default heroSlider
